import React from 'react';
import * as MaterialIcons from '@mui/icons-material'; // Importing all Material UI icons

const Icon = ({ icon, size = 24, color = 'orange' }) => {
  const iconName = typeof icon === 'string' ? icon : 'Create'; // Default icon name

  // Dynamically retrieve the icon from MaterialIcons
  const IconComponent = MaterialIcons[iconName];

  return (
    <>
      {IconComponent ? (
        // If the icon is found, render it with the desired styles
        <IconComponent fontSize="inherit" style={{ fontSize: size, color }} />
      ) : (
        // If no valid icon is found, render nothing or a fallback
        null
      )}
    </>
  );
};

export default Icon;
